<template>
  <div class="swiper-container">
    <el-carousel :autoplay="true" :interval="3000" arrow="always"  trigger="click" height="390px">
      <el-carousel-item v-for="(item, index) in constant.homeList" :key="index">
        <div class="swiper-slide" :key="index">
          <img class="company_photo" :src="item.path"   />
          <div class="company_content">
            <div class="name">{{ item.desc }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import constant from '../../constant/constant.js'
export default {
  data() {
    return {
      homeImgList: constant.homeList
    }
  },
  computed:{
    constant() {
      console.log(constant.homeList)
      return constant;
    }
  },
}
</script>

<style scoped lang="scss">

  .swiper-container{
      margin-top: 5px;
      width: 100%;
      height: 100%;
      // height: 413px;
      overflow: hidden;
      position: relative;
      .swiper-slide{
        width: 100!important;
        height: 100%;
        // height: 410px;
        background: #fff;
        border-radius: 2px;
        overflow: hidden;
        border: 1px solid #fff;
        display: flex;
        flex-direction: column;
        img{
          max-width: 100%;
          height: 100%;
          display: block;
          background-repeat: no-repeat;
          -moz-background-size:88% 88%;
          background-size:88% 88%;
          background-position: center center;
        }
      }
    }
  .company_photo{
    max-width: 100%;
    height: 100%;
    position: relative;
    opacity: 1;
  }
  .company_back {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10001;
    display:none;
    filter:alpha(opacity=60);
    background-color: #777;
    opacity: 0.5;
    -moz-opacity: 0.5;
  }

  // .company_content{
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   -ms-transform: translate(-50%, -50%);
  //   max-width: 100%;
  //   display: block;
  //   z-index: 4;
  // }
</style>

<style scoped lang="scss">


.swiper-container .el-carousel {
  height: 100%;
}
.swiper-container .el-carousel >>> .el-carousel__container {
  height: 100%;
}
.swiper-container .el-carousel >>> .el-carousel__item {
  height: 100%;
}
.swiper-container .el-carousel >>> .el-carousel__item > .el-row {
  height: 100%;
}
.swiper-container .el-carousel >>> .el-carousel__item > .el-row > .banner_img {
  height: 100%;
}
/* 轮播图指示标样式 */
.swiper-container .el-carousel >>> .el-carousel__indicators--horizontal {
  height: 45px;
  display: flex;
  left: 85%;
  bottom: 10px;
}
/* 轮播图指示标样式 */
.swiper-container .el-carousel >>> .el-carousel__arrow--left {
  display: none;
}
.swiper-container .el-carousel >>> .el-carousel__arrow--right {
  display: none;
}
.swiper-container
  .el-carousel
  >>> .el-carousel__indicator--horizontal
  .el-carousel__button {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}

.swiper-container .el-carousel >>> .is-active .el-carousel__button {
  background: #31e5f5;
  width: 2rem;
  border-radius: 0.5rem;
}
/* end */

.home-middle-bottom {
  height: 52%;
  margin-top: 3%;
}

.swiper-container img {
  display: block;
  width: 100%;
  height: 100%;
}

.bannerImg {
  height: 100% !important;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}

.banner_img {
  position: relative;
}

.company_content .name {
  line-height: 50px;
  color: #fff;
  text-align: left;
  padding-left: 10px;
}

.company_content {
  width: 100%;
  height: 50px;
  background-color: #000;
  position: absolute;
  bottom: 0vh;
  opacity: 0.5;
  /*z-index: 9999;*/
}

</style>



// WEBPACK FOOTER //
// src/components/swiper/News_Home.vue